export function formatTime (getTime) {
  var timestamp
  // 获取当前时间戳
  if (getTime === ''){
    timestamp = new Date().getTime()
  } else {
    timestamp = getTime
  }

  // 创建一个新的 Date 对象，使用时间戳作为参数
  var date = new Date(timestamp);

// 获取时、分、秒、毫秒
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var milliseconds = date.getMilliseconds();

// 格式化时、分、秒、毫秒，确保它们始终是两位数
  hours = (hours < 10) ? "0" + hours : hours;
  minutes = (minutes < 10) ? "0" + minutes : minutes;
  seconds = (seconds < 10) ? "0" + seconds : seconds;
  milliseconds = (milliseconds < 10) ? "00" + milliseconds : (milliseconds < 100) ? "0" + milliseconds : milliseconds;

// 将时分秒毫秒组合成可读的格式
  var timeString = hours + ":" + minutes + ":" + seconds + "." + milliseconds;

// 输出可读的时分秒毫秒
  return timeString
}

export function readTime () {
  return formatTime('')
}
